import {fromJS} from 'immutable';

import albeyTeach from 'assets/images/albey/albey-teach-smaller.png';
import zuriSmaller from 'assets/images/zuri/zuri-smaller.png';

export const navLinks = fromJS([
  {
    name: 'Explore',
    dropdown: [
      {
        name: 'For Teachers',
        hardLink: true,
        route: '/solutions-teachers'
      },
      {
        name: 'For Admins',
        hardLink: true,
        route: '/solutions-admins'
      },
      {
        name: 'For Students',
        hardLink: true,
        route: '/solutions/students'
      },
      {
        name: 'Research',
        hardLink: true,
        route: '/research'
      },
      {
        name: 'Professional Development',
        hardLink: true,
        route: '/solutions/professional-development'
      },
      {
        name: 'Find Your State',
        hardLink: true,
        route: '/solutions-states'
      }
    ]
  },
  {
    name: 'Library'
  },
  {
    name: 'Pricing',
    dropdown: {
      leftContent: {
        name: 'Students, Tutors & Homeschools',
        description:
          'Self-paced AP, SAT, ACT prep and access to premium adaptive features and core question banks.',
        image: zuriSmaller,
        cta: 'Explore options',
        route: '/pricing-students',
        hardLink: true
      },
      rightContent: {
        name: 'Teachers & Schools',
        description:
          'All-inclusive pricing, volume discounts, rostering and integrations, and professional development.',
        image: albeyTeach,
        cta: 'Explore options',
        route: '/pricing-schools',
        hardLink: true
      }
    }
  },
  {
    name: 'Help & Resources',
    hideForNonMobile: true,
    dropdown: [
      {
        name: 'Help Docs',
        hardLink: true,
        route: 'https://help.albert.io'
      },
      {
        name: 'Live Teacher Support Session',
        hardLink: true,
        route: 'https://app.lemcal.com/@albert-adoption-team/teacher-talk'
      }
    ]
  }
]);
